import { render, staticRenderFns } from "./GaiminCheck.vue?vue&type=template&id=bba54c28"
import script from "./GaiminCheck.vue?vue&type=script&lang=js"
export * from "./GaiminCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports